import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { createElement, registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { DropDownMenuItem } from "./DropDownMenuItem";

export class DropDownMenuLoader extends DropDownMenuItem {
    /**Popisek pro loader*/
    protected _loaderElement: HTMLElement;

    public override set locKey(val: string) {
        if (this._captionElement) {
            Localization.getTextPromise(val).then((locItem) => this._captionElement.innerText = locItem);
            this._locKey = val;
        }
    }

    /**
     * Vytvoří položku dropdown menu, která má v ikoně animovaný loader a popisek.
     * @param loaderlocKey Popisek loaderu
     */
    public static createMenuLoader(loaderlocKey: string): DropDownMenuLoader {
        const element = new DropDownMenuLoader();
        element.locKey = loaderlocKey;
        return element;
    }

    protected override _createElement(): void {
        super._createElement();
        this.classList.add("DropDownMenuItem", "item-loader");
    }

    protected override _createIconElement(): void {
        super._createIconElement();

        //loader
        this._loaderElement = createElement({ classes: "element-loader" });
        const loader = createElement({ classes: "loader" });
        const right = createElement({ classes: "right" });
        const left = createElement({ classes: "left" });

        this._loaderElement.appendChild(loader);

        loader.appendChild(right);
        right.appendChild(createElement({ classes: "border" }));

        loader.appendChild(left);
        left.appendChild(createElement({ classes: "border" }));
        this._iconElement.appendChild(this._loaderElement);
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuLoader", DropDownMenuLoader);
